// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-fortawesome-box{
    display: flex;
    flex-wrap: wrap;
}
.softlite-button-select-icon{
    border: 1px solid #e6e7e9;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.softlite-button-select-icon:focus{
    outline: none !important;
    box-shadow: none !important;
}
.softlite-fortawesome-box__left{
    display: flex;
    flex-direction: column;
    width: 14%;
}
.softlite-fortawesome-box__right{
    display: flex;
    flex-wrap: wrap;
    width: 85%;
    gap: 11px;
    justify-content: space-between;
}
.softlite-button-select-category:focus{
    outline: none !important;
    box-shadow: none !important;
}
.softlite-button-select-category.softlite-active{
    color: #007cba;
}
.softlite-fortawesome-box__right>div>div{
    width: 100% !important;
    display: flex;
    height: auto !important;
    gap: 10px;
    flex-direction: row;
    flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/fontawesome/fontawesome.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,SAAS;IACT,8BAA8B;AAClC;AACA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":[".softlite-fortawesome-box{\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}\r\n.softlite-button-select-icon{\r\n    border: 1px solid #e6e7e9;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n.softlite-button-select-icon:focus{\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n}\r\n.softlite-fortawesome-box__left{\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 14%;\r\n}\r\n.softlite-fortawesome-box__right{\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    width: 85%;\r\n    gap: 11px;\r\n    justify-content: space-between;\r\n}\r\n.softlite-button-select-category:focus{\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n}\r\n.softlite-button-select-category.softlite-active{\r\n    color: #007cba;\r\n}\r\n.softlite-fortawesome-box__right>div>div{\r\n    width: 100% !important;\r\n    display: flex;\r\n    height: auto !important;\r\n    gap: 10px;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
